export default __webpack_public_path__ + "faf80c90a320c76105f5bafba5363336.png";